/**
 * The next step a halted or failed DEMO record shows in place of «start it» /
 * «retry it» (#1503). Demo records are sample data with no source: the start
 * and the retry both leave `is_demo` out, so the instruction a real record gets
 * would point at a button the demo never shows. Key `records.demoRecordNext`.
 */
export const DEMO_RECORD_NEXT =
  'This is a sample record: demo records are never started or retried. Your own conversations get these actions.';
